import React from 'react'

/**
 * Cabeçalho das páginas internas: a curva colorida atrás da barra, o título (com breadcrumbs opcionais) e as três
 * bolinhas. Substitui as cópias que havia em cada layout. As classes padrão são as da maioria das telas; as telas com
 * medidas próprias (carrinho, produtos, páginas do CMS) trocam só a parte que difere, para o visual não mudar.
 */
export interface IPageHeroProps {
    /** Conteúdo do h1 padrão. */
    title?: React.ReactNode
    /** Cabeçalho próprio no lugar do h1 padrão (ex.: `PageTitle`, que escolhe o título pela rota). */
    heading?: React.ReactNode
    breadcrumbs?: React.ReactNode
    /** Cor da curva (classe de fundo). */
    color?: string
    curveClassName?: string
    containerClassName?: string
    contentClassName?: string
    titleClassName?: string
    dotsClassName?: string
}

export const HERO_TITLE_CLASS = 'text-white text-[46px] max-md:text-[36px] font-semibold ml-4 md:ml-8 title-head-size'

const PageHero: React.FC<IPageHeroProps> = ({
    title,
    heading,
    breadcrumbs,
    color = 'bg-light-blue-inactive',
    curveClassName,
    containerClassName = 'container relative flex flex-row h-[205px] justify-left items-center z-40 mt-24',
    contentClassName = 'flex flex-col lg:ml-8',
    titleClassName = HERO_TITLE_CLASS,
    dotsClassName = 'absolute flex justify-start gap-4 ml-4 controls -bottom-2',
}) => {
    const curve =
        curveClassName ??
        `w-full ${color} rounded-b-[100px] lg:rounded-b-[150px] xl:rounded-b-[250px] max-md:rounded-b-[40px] h-[850px] absolute -top-[550px] transition-all z-10`

    return (
        <div className="w-full relative flex justify-center max-lg:-mt-[50px] lg:-mt-[100px]">
            <div className={curve} />
            <div className={containerClassName}>
                <div className={contentClassName}>
                    {breadcrumbs}
                    {heading ?? <h1 className={titleClassName}>{title}</h1>}
                    <div className={dotsClassName}>
                        <div className="w-5 h-5 rounded-full bg-primary-green" />
                        <div className="w-5 h-5 rounded-full bg-orange" />
                        <div className="w-5 h-5 ml-16 rounded-full bg-primary" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageHero
